import {
  normalizePanNumber as normalizePanNumberCore,
  validatePanNumber as validatePanNumberCore,
} from "../../shared-utils/panValidation.mjs";

export {
  EXAMPLE_VALID_PAN,
  PAN_FORMAT_PATTERN,
  VALID_PAN_HOLDER_TYPES,
} from "../../shared-utils/panValidation.mjs";

export interface PanValidationResult {
  valid: boolean;
  normalized?: string;
  error?: string;
}

export function normalizePanNumber(pan: string): string {
  return normalizePanNumberCore(pan);
}

export function validatePanNumber(
  pan: string,
  options: { required?: boolean } = {}
): PanValidationResult {
  return validatePanNumberCore(pan, options);
}
